module.exports = __webpack_public_path__ + "static/insta-logo-c85eb2535a5be3e0a0efbfb5f2545bd6.png";